var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571 6L11.7101 1.56632C12.063 1.21263 12.063 0.618944 11.7101 0.26526C11.3571 -0.0884241 10.7647 -0.0884241 10.4118 0.26526L5.9874 4.69895L1.56303 0.26526C1.21009 -0.0884241 0.617644 -0.0884241 0.264703 0.26526C-0.0882384 0.618944 -0.0882384 1.21263 0.264703 1.56632L4.68908 6L0.264703 10.4337C-0.0882384 10.7874 -0.0882384 11.3811 0.264703 11.7347C0.441173 11.9116 0.680671 12 0.920167 12C1.15966 12 1.38655 11.9116 1.57563 11.7347L6 7.30105L10.4244 11.7347C10.6008 11.9116 10.8403 12 11.0798 12C11.3193 12 11.5462 11.9116 11.7353 11.7347C12.0882 11.3811 12.0882 10.7874 11.7353 10.4337L7.28571 6Z",
    fill: "#C3B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2235fe5c3b2895f9bff298214c4f8b9b.svg";
export { ForwardRef as ReactComponent };